export function escapeHtml(value: unknown): string {
  return (typeof value === 'string' ? value : typeof value === 'number' || typeof value === 'boolean' || typeof value === 'bigint' ? String(value) : '').replace(/[&<>"']/g, ch => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  }[ch] || ch))
}

export function currency(amount: number | string): string {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(amount))
}

export function toJSON(obj: unknown): string {
  return JSON.stringify(obj, (_key: string, value: unknown) => (typeof value === 'bigint' ? value.toString() : value), 4)
}

export function formatTimeRemaining(seconds: number | string): string {
  const s = Math.max(0, Number(seconds || 0))
  const days = Math.floor(s / 86_400)
  const hours = Math.floor((s % 86_400) / 3_600)
  const minutes = Math.floor((s % 3_600) / 60)
  if (days > 0) return `${days}d ${hours}h`
  if (hours > 0) return `${hours}h ${minutes}m`
  return `${minutes}m`
}
